import { defineComponent as _defineComponent } from 'vue'

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    CardAssignments: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'CardAssignments' };

import { ref, computed } from 'vue';
import type { BvTableFieldArray } from 'bootstrap-vue';

import CardLoadable from '@components/Cards/CardLoadable.vue';

import { dateFilter } from '@filters/date';
import { secToHmsFilter } from '@filters/sec-to-hms';
import { ScoredAssignment } from '@utils/reports';

/**
 * `CardAssignments` component properties.
 */
export interface Props {
  assignments: ScoredAssignment[];
  loading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    assignments: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  assignments: ScoredAssignment[];
  loading?: boolean;
};

const FIELDS: BvTableFieldArray = [
  {
    key: 'dueDate',
    label: 'Due Date',
    sortable: true,
    formatter: (value: string) => {
      return dateFilter(value, 'MM/dd/yyyy');
    },
  },
  {
    key: 'dateRange',
    label: 'Date Range',
    formatter: (_value, _key, { startDate, endDate }: ScoredAssignment) => {
      return dateRangeFormatter(startDate, endDate);
    },
  },
  {
    key: 'minimumScore',
    label: 'Minimum Score',
    formatter: (value: ScoredAssignment['minimumScore']) => {
      return value ? `${value}` : 'N/A';
    },
  },
  {
    key: 'totalTime',
    label: 'Total Time (hh:mm:ss)',
    formatter: (totalTime: ScoredAssignment['totalTime']) => {
      return totalTime ? secToHmsFilter(totalTime) : 'N/A';
    },
  },
  {
    key: 'module',
    label: 'Scene/Module',
    formatter: (_value, _key, { module, scene }: ScoredAssignment) => {
      return `${scene.name} | ${module.name}`;
    },
    sortable: true,
  },
  {
    key: 'details',
    label: 'Details',
    sortable: true,
  },
  {
    key: 'report',
    label: 'Completed',
    sortable: true,
    formatter: (value: ScoredAssignment['report']) => {
      return `${value.completed ? 'Yes' : 'No'}`;
    },
  },
];



const perPage = ref(5);
const currentPage = ref(1);

/** ... */
const rows = computed(() => {
  return props.assignments.length;
});

//#region Helper Functions

/**
 * ...
 *
 * @param startDate ...
 * @param endDate ...
 * @return ...
 */
function dateRangeFormatter(startDate: unknown, endDate: unknown) {
  if (typeof startDate !== 'string' || typeof endDate !== 'string') {
    return 'N/A';
  }

  const formattedStartDate = dateFilter(startDate, 'MM/dd/yyyy').toString();
  const formatteEndDate = dateFilter(endDate, 'MM/dd/yyyy').toString();

  return `${formattedStartDate} - ${formatteEndDate}`;
}

//#endregion Helper Functions

return { __sfc: true,FIELDS, props, perPage, currentPage, rows, dateRangeFormatter, CardLoadable }
}

})